export default {
  MILLISECONDS: 1000,
  SECONDS: 60,
  MINUTES: 60,
  HOURS: 24,
  COUNT_DAY: 6,

  SECONDS_PER_MINUTE: 60,

  MAX_LENGTH: 50
};



// WEBPACK FOOTER //
// ./src/modules/appeals/Constants.js